import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "sub_contents_wrap error" };
const _hoisted_2 = { class: "error_container" };
const _hoisted_3 = /*#__PURE__*/ _createElementVNode("div", { class: "error_code" }, "404", -1);
const _hoisted_4 = { class: "error_explanation" };
const _hoisted_5 = /*#__PURE__*/ _createElementVNode("br", null, null, -1);
const _hoisted_6 = { class: "basic-button-container" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_BasicButton = _resolveComponent("BasicButton");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _createElementVNode("div", _hoisted_4, [
                _createTextVNode(_toDisplayString(_ctx.$t('message.page_missing')), 1),
                _hoisted_5,
                _createElementVNode("small", null, _toDisplayString(_ctx.$t('message.try_again_later')), 1)
            ]),
            _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_BasicButton, { onClick: _ctx.goHome }, {
                    default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('common.go_home')), 1)
                    ]),
                    _: 1
                }, 8, ["onClick"])
            ])
        ])
    ]));
}
